// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"467b94b1","437":"97281628","582":"e956687d","787":"dc2b54a5","889":"b7124efa","929":"77c58c38","949":"58815252"}[chunkId] + ".chunk.js";
};